module.exports = __webpack_public_path__ + "21abdb82122a172b5fc7efed624608d3.svg";